<template>
  <div class="table">
    <div ref="caozuo" class="headerCaozuo">
      <div>
        <el-button size="small" plain @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <el-button size="small" @click="handleAdd">
          <i class="el-icon-plus"></i> 新增
        </el-button>
        <el-button size="small" @click="handleDaoru">
          <i class="el-icon-download"></i> 导入
        </el-button>
      </div>
      <div>
        <!-- //搜索 -->
        <el-form :model="formes" :inline="true" label-width="90px">
          <el-form-item label style="margin-bottom: 0">
            <el-select
              v-model="select"
              placeholder="请选择"
              size="small"
              class="especially"
              style="width: 110px"
            >
              <el-option label="手机号码" :value="1"></el-option>
            </el-select>
            <el-input
              @input="esarchang(1)"
              size="small"
              placeholder="请输入手机号码"
              v-model="formes.mobile"
              class="especially2"
              style="width: 160px"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="用户ID"></el-table-column>
      <el-table-column label="昵称">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码"> </el-table-column>
      <el-table-column label="用户类型">
        <template slot-scope="scope">
          <span v-if="scope.row.is_admin !== 1">{{
            calltype(scope.row.UserInfo.call_type_id)
          }}</span>
          <span v-else class="qing"> 企业主 </span>
        </template>
      </el-table-column>
      <el-table-column label="账号状态">
        <template slot-scope="scope">
          <span :class="[scope.row.UserInfo.status == 1 ? 'qing' : 'jing']">{{
            scope.row.UserInfo.status == 1 ? "启用" : "禁用"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="录音状态">
        <template slot-scope="scope">
          <span
            :class="[
              scope.row.UserInfo.is_open_recording == 1 ? 'qing' : 'jing',
            ]"
          >
            {{ scope.row.UserInfo.is_open_recording == 0 ? "关闭" : "开启" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="app_expiration_time"
        label="APP授权到期时间"
      ></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            plain
            v-if="scope.row.is_bind == 1 && scope.row.is_admin !== 1"
            @click="handleUnbind(scope.row)"
            >解绑手机号</el-button
          >
          <el-button
            type="success"
            size="mini"
            plain
            v-if="scope.row.is_bind == 0 && scope.row.is_admin !== 1"
            @click="handleBind(scope.row)"
            >绑定手机号</el-button
          >
          <el-button
            type="danger"
            size="mini"
            plain
            @click="deletes(scope.row)"
            v-if="scope.row.is_admin !== 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <AddAtTheInformation
      v-if="modalVisible == 'add'"
      :isShow="modalVisible == 'add'"
      :company_id="company_id"
      @close="modalVisible = null"
    ></AddAtTheInformation>
    <bindAtTheInformation
      v-if="modalVisible == 'bind'"
      :isShow="modalVisible == 'bind'"
      :rowData="rowData"
      :company_id="company_id"
      @close="modalVisible = null"
    ></bindAtTheInformation>
    <unbindAtTheInformation
      v-if="modalVisible == 'unbind'"
      :isShow="modalVisible == 'unbind'"
      :rowData="rowData"
      @close="modalVisible = null"
    ></unbindAtTheInformation>
    <DaoruExtion
      v-if="modalVisible == 'daoru'"
      :isShow="modalVisible == 'daoru'"
      :company_id="company_id"
      @close="modalVisible = null"
    ></DaoruExtion>
  </div>
</template>

<script>
import { getData } from "@/api/index";
import DaoruExtion from "./components/DaoruExtion";
import AddAtTheInformation from "./components/AddAtTheInformation";
import bindAtTheInformation from "./components/bindAtTheInformation";
import unbindAtTheInformation from "./components/unbindAtTheInformation";
export default {
  props: {
    company_id: Number,
  },
  components: {
    DaoruExtion,
    AddAtTheInformation,
    bindAtTheInformation,
    unbindAtTheInformation,
  },
  data() {
    return {
      select: 1,
      zhanshi: "800px",
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      dialogDaoruUserVisible: false,
      form: {},
      fileList: [],
      formes: {
        mobile: "",
        pagesize: 20,
        page: 1,
      },
      callTypeArr: [],
      modalVisible: "",
      rowData: {},
    };
  },
  created() {
    this.getMainData();
    this.getCallSeat();
  },
  mounted() {
    setTimeout(() => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      this.zhanshi = H - caozuo - 270;
    }, 100);
    const that = this;
    window.onresize = () => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      that.zhanshi = H - caozuo - 270;
    };
  },
  methods: {
    handleDaoru() {
      this.modalVisible = "daoru";
    },
    handleUnbind(row) {
      this.modalVisible = "unbind";
      this.rowData = row;
    },
    handleBind(row) {
      this.modalVisible = "bind";
      this.rowData = row;
    },
    handleAdd() {
      this.modalVisible = "add";
    },
    calltype(val) {
      for (let i of this.callTypeArr) {
        if (i.call_type_id == val) return i.callTypeInfo.card;
      }
    },
    getCallSeat() {
      getData("call.CallSeatController/listAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.callTypeArr = res.data;
      });
    },
    shuaxin() {
      this.formes.mobile = "";
      this.esarchang(1);
      this.$message({ message: "刷新成功", type: "success" });
    },
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let params = {
        pagesize: this.pagesize,
        page: this.currentPage,
        company_id: this.company_id,
      };
      if (this.formes.mobile) {
        params.mobile = this.formes.mobile;
      }
      this.getMainData(params);
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    getMainData(
      params = {
        page: this.currentPage,
        pagesize: this.pagesize,
        company_id: this.company_id,
      }
    ) {
      getData("company.CompanyUserController/pageAction", params).then(
        (res) => {
          if (res.code !== 200) return this.$message.error(res.message);
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      );
    },
    // 删除
    deletes(e) {
      this.$confirm("是否要删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getData("company.CompanyUserController/delAction", {
            idStr: e.id,
            company_id: this.company_id,
          }).then((res) => {
            if (res.code !== 200) return this.$message.error(res.message);
            this.$message({ message: "删除成功", type: "success" });
            this.esarchang();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.esarchang();
    },
    current_change(currentPage) {
      this.currentPage = currentPage;
      this.esarchang();
    },
  },
};
</script>

<style lang="less" scoped>
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
.avatar-uploader {
  display: none;
}
.content {
  height: 300px;
  overflow: hidden;
  /deep/img {
    width: 360px;
  }
}
.content:hover {
  overflow-y: overlay;
}
::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  // width: 18px !important;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgb(182, 182, 182);
  box-shadow: inset 0 0 5px rgb(182, 182, 182);
  border: 7px solid transparent;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
}
</style>
<style lang="less" scoped>
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}
.qing {
  color: #46c160;
}
.jing {
  color: #ec5952;
}
</style>
<style src="@/assets/css/index.css" scoped></style>
<style lang="less" src="@/assets/css/comparison.less" scoped></style>
